// extracted by mini-css-extract-plugin
module.exports = {"nav":"fonts-module--nav--BExfU","header":"fonts-module--header--143v1","body":"fonts-module--body--2Lk7F"};